export const meals_state = {
	meals: {
		meals: [],
		meal_plans: [],
		meal_plan_infos: [],
		likes: null,
		delivery_offsets: {}
	}
};
